import _ from 'lodash';
import axios from 'axios';
import { iwalyNotify } from '@/notify';
import Exceptions from '@/api/lang.json';

/**
 * API BASE URL
 *
 * Для локального теста нужен реальный API URL.
 * Если baseURL пустой, запросы пойдут на localhost:8080
 * и будет 404 по /countries, /regions, /serviceCategories.
 */

/**
 * Переключатель окружения.
 *
 * Для production:
 * const API_ENV = 'production';
 *
 * Для staging:
 * const API_ENV = 'staging';
 */
const API_ENV = 'production';

// const API_ENV = 'staging';

const API_URLS = {
  production: 'https://api.iwaly.ru/web',
  staging: 'https://api-staging.iwaly.ru/web',
};

/**
 * Если задан .env.local / .env.production:
 *
 * VUE_APP_BASE_URL=https://api.iwaly.ru/web
 *
 * то будет использоваться он.
 *
 * Если переменной нет — используется API_URLS[API_ENV].
 */
const BASE_URL = process.env.VUE_APP_BASE_URL || API_URLS[API_ENV];

export const axiosInstance = axios.create({
  baseURL: BASE_URL,
});

/**
 * Временно оставляем для проверки.
 * В браузере: F12 → Console.
 */
console.log('IWALY API BASE_URL:', BASE_URL);

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      const e = _.get(error.response, 'data.error');
      const message = _.get(Exceptions, e) || 'Что-то пошло не так. Произошла ошибка';

      iwalyNotify.error({
        text: message,
      });
    }

    return Promise.reject(error);
  },
);

export default {
  post: async (path, payload) => axiosInstance.post(path, payload),
  get: async (path, payload) => axiosInstance.get(path, payload),
};
